import React, { useEffect, useState } from 'react';

const ItemScore = (props) => {

    return (
        <div className="item-current itemscore">
            <div className="details-lattery">
                <div className="body-lottery">
                    <h4>{props.data.title}</h4>
                    <span>{props.data.string_date}</span>
                    <span> {props.lose ? 'امتیاز خرج شده' : 'امتیاز کسب شده'}  : <b>{props.data.score}</b></span>
                </div>
            </div>
            {props.lose ?
                <i className="icon-down-arrow-not-true"></i>
                :
                <i className="icon-down-arrow-true"></i>
            }
        </div>
    );
}

export default ItemScore;